module.exports = __webpack_public_path__ + "img/one column.2ef9997e.svg";